"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _uiLogger = _interopRequireDefault(require("@ow/ui-logger"));
var _lodash = _interopRequireDefault(require("lodash.get"));
var _analytics = require("../../constants/analytics");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var log = (0, _uiLogger.default)();
var adobeAppMeasurement = function adobeAppMeasurement() {
  // eslint-disable-next-line no-undef
  if (!(0, _lodash.default)(global, 'window')) {
    return;
  }
  window.adobeAnalyticsMethods = window.adobeAnalyticsMethods || {};
  window.adobeAnalyticsMethods.pageViewCreateAppMeasurement = function (appMeasurement) {
    switch (window.digitalData.page.pageInfo.pageId) {
      case _analytics.PRODUCT_DETAILS_PAGE_ID:
        return window.adobeAnalyticsMethods.setupProductDetailsPage(appMeasurement, window.digitalData);
      case _analytics.CATEGORY_PAGE:
        return window.adobeAnalyticsMethods.resetProductAndSearchAnalytics(appMeasurement);
      case _analytics.ERROR_PAGE:
        return window.adobeAnalyticsMethods.setupErrorPage(appMeasurement);
      case _analytics.CHECKOUT_PAGE:
        return window.adobeAnalyticsMethods.setPropsForCheckout(appMeasurement, window.digitalData);
      case _analytics.SEARCH_RESULTS_PAGE:
        return window.adobeAnalyticsMethods.buildListVar(appMeasurement, window.digitalData);
      default:
        return appMeasurement;
    }
  };

  // Clear all sub category and product information.
  // As of 13/09/2018, this is being called as part of FRA: Search: Page View on DTM.
  window.adobeAnalyticsMethods.resetAnalyticsVariables = function (appMeasurement) {
    appMeasurement.products = undefined;
    appMeasurement.eVar3 = undefined;
    appMeasurement.eVar4 = undefined;
    appMeasurement.eVar5 = undefined;
    return appMeasurement;
  };
  window.adobeAnalyticsMethods.setFakeProductForSearch = function (appMeasurement) {
    appMeasurement.products = ";".concat(appMeasurement.eVar30);
    return appMeasurement;
  };
  window.adobeAnalyticsMethods.setupProductDetailsPage = function (appMeasurement, details) {
    appMeasurement = window.adobeAnalyticsMethods.transferProductDetailsFromGivenObject(appMeasurement, details);
    appMeasurement.eVar30 = details.latestQuery ? details.latestQuery : undefined;
    return appMeasurement;
  };
  window.adobeAnalyticsMethods.resetProductAndSearchAnalytics = function (appMeasurement, isPdp) {
    if (isPdp) {
      appMeasurement.events = 'event13,prodView';
    } else {
      appMeasurement.products = undefined;
      appMeasurement.events = undefined;
    }
    appMeasurement.eVar30 = undefined; // query (alias: onSiteSearchTerm)
    appMeasurement.eVar31 = undefined; // nbHits (alias: onSiteSearchResults)
    return appMeasurement;
  };
  window.adobeAnalyticsMethods.setupErrorPage = function (appMeasurement) {
    appMeasurement.pageType = _analytics.ERROR_PAGE;
    return appMeasurement;
  };
  window.adobeAnalyticsMethods.setPaginationDetails = function (appMeasurement, details) {
    appMeasurement.eVar35 = details.pageNumber;
    return appMeasurement;
  };

  // This function provides a standard way to prepare the details of the list of products for passing in the tag
  window.adobeAnalyticsMethods.transferProductDetailsFromGivenObject = function (appMeasurement, details) {
    // Set events and clear eVars
    appMeasurement = window.adobeAnalyticsMethods.resetProductAndSearchAnalytics(appMeasurement, true);
    return window.adobeAnalyticsMethods.buildProductsString(appMeasurement, details);
  };
  window.adobeAnalyticsMethods.buildProductsString = function (appMeasurement, details) {
    appMeasurement.products = '';
    try {
      var productStrings = details.product.map(function (product) {
        return (0, _lodash.default)(product, 'category.primaryCategory', '') + ';' + (product.productInfo.productID || '') + ';;;;eVar19=' + (product.productInfo.dinkus || 'none') + '|eVar20=' + (product.productInfo.rating || '') + '|eVar184=' + (product.productInfo.isEarlyAccessProduct || '') + '|eVar41=' + (product.productInfo.bundleSlot || '') + '|eVar54=' + (product.attributes.webHierarchy || '').replace(',', '_') + '|eVar25=' + (product.attributes.has2hrCnCBadgeOn || '') + '|eVar187=' + (details.searchTerm || '') + '|eVar189=' + (product.attributes.isAltCategory || '') + '|eVar198=' + (product.attributes.businessPriceFlag || 'N') + '|eVar150=' + (product.attributes.exclusiveProductFlag || 'N');
      });
      appMeasurement.products = appMeasurement.products + productStrings.join(',');
    } catch (error) {
      log.error(error);
    }
    return appMeasurement;
  };
  window.adobeAnalyticsMethods.clearListVar = function (appMeasurement) {
    appMeasurement.list2 = undefined;
    return appMeasurement;
  };
  window.adobeAnalyticsMethods.buildListVar = function (appMeasurement, details) {
    appMeasurement.linkTrackVars = 'list2';
    appMeasurement.list2 = details.refineFilter;
    return appMeasurement;
  };
  window.adobeAnalyticsMethods.buildDataLayerForMatchingAccessories = function (appMeasurement, details) {
    appMeasurement = window.adobeAnalyticsMethods.transferProductDetailsFromGivenObject(appMeasurement, details.matchingAccessories);
    appMeasurement.linkTrackVars = appMeasurement.linkTrackVars + ',products,events';
    appMeasurement.linkTrackEvents = appMeasurement.linkTrackVars + 'event127';
    appMeasurement.events = 'event127';
    return appMeasurement;
  };
  window.adobeAnalyticsMethods.buildDataLayerForSelectCancelItem = function (appMeasurement, details) {
    appMeasurement.products = ";".concat(details.sku || '');
    appMeasurement.linkTrackVars = appMeasurement.linkTrackVars + ',products,events';
    appMeasurement.linkTrackEvents = appMeasurement.linkTrackVars + 'event140';
    appMeasurement.events = 'event140';
    return appMeasurement;
  };
  window.adobeAnalyticsMethods.buildDataLayerForOnlineReturnsSuccess = function (appMeasurement, details) {
    appMeasurement.products = (details.sku || []).map(function (sku) {
      return ';'.concat(sku);
    }).join(',');
    appMeasurement.linkTrackVars = appMeasurement.linkTrackVars + ',products,events';
    appMeasurement.linkTrackEvents = appMeasurement.linkTrackVars + 'event141';
    appMeasurement.events = 'event141';
    return appMeasurement;
  };
  window.adobeAnalyticsMethods.buildDataLayerForAddToCart = function (appMeasurement, details) {
    var _satellite = (0, _lodash.default)(global, 'window._satellite');
    appMeasurement = window.adobeAnalyticsMethods.transferProductDetailsFromGivenObject(appMeasurement, details.addToCart);
    appMeasurement.eVar30 = details.addToCart.searchTerm;
    //make sure the s.tl beacon knows to pick up the products variable in addition to variables set directly in the rule interface
    appMeasurement.linkTrackVars = appMeasurement.linkTrackVars + ',products,events';
    appMeasurement.linkTrackEvents = appMeasurement.linkTrackVars + 'scOpen,scAdd';
    appMeasurement.events = 'scAdd';
    //Empty Cart
    try {
      if ((0, _lodash.default)(_satellite, 'getVar') && _satellite.getVar('events') && _satellite.getVar('events').indexOf('scOpen') > -1) {
        appMeasurement.events = appMeasurement.apl(appMeasurement.events, 'scOpen,scAdd', ',', 1);
        //Non Empty Cart
      } else if ((0, _lodash.default)(_satellite, 'getVar') && _satellite.getVar('events') && _satellite.getVar('events').indexOf('scOpen') < 0) {
        appMeasurement.events = appMeasurement.apl(appMeasurement.events, 'scAdd', ',', 1);
      }
    } catch (error) {
      log.error(error);
    }
    return appMeasurement;
  };
  window.adobeAnalyticsMethods.buildDataLayerForCompareProducts = function (appMeasurement, details) {
    appMeasurement = window.adobeAnalyticsMethods.transferProductDetailsFromGivenObject(appMeasurement, details.compareProducts);
    appMeasurement.linkTrackVars = appMeasurement.linkTrackVars + ',products,events';
    appMeasurement.linkTrackEvents = appMeasurement.linkTrackVars + 'event150';
    appMeasurement.events = 'event150';
    return appMeasurement;
  };
  var getConfigurableTypeEvars = function getConfigurableTypeEvars(configurableType) {
    switch (configurableType) {
      case _analytics.BTS_CONFIGURABLE_SLS_TYPE:
        return "|eVar46=".concat(_analytics.configurableProductMap[_analytics.BTS_CONFIGURABLE_SLS_TYPE]);
      case _analytics.BTS_CONFIGURABLE_SRP_TYPE:
        return "|eVar46=".concat(_analytics.configurableProductMap[_analytics.BTS_CONFIGURABLE_SRP_TYPE]);
      default:
        return '';
    }
  };
  window.adobeAnalyticsMethods.buildProductsVariable = function (items) {
    return items.reduce(function (acc, item) {
      var productInfo = (0, _lodash.default)(item, 'productInfo', {});
      var price = item.price / 100;
      var linePrice = price.toFixed(2); // to be clear the price takes into account the qty already.

      acc += ";".concat(productInfo.productID, ";").concat(item.quantity, ";").concat(linePrice, ";;eVar45=").concat(productInfo.productType).concat(getConfigurableTypeEvars(productInfo.configurableType), ",");
      return acc;
    }, '');
  };
  window.adobeAnalyticsMethods.setPropsForCheckout = function (appMeasurement, digitalData) {
    appMeasurement.products = '';
    var cart = digitalData.cart;
    var product = digitalData.product;
    if (!cart && !product) {
      return appMeasurement;
    }
    if (cart && cart.item.length > 0) {
      appMeasurement.products = window.adobeAnalyticsMethods.buildProductsVariable(cart.item);
    } else if (product.length > 0) {
      // TODO work out if this is ever used and delete
      appMeasurement.products = product.reduce(function (acc, item) {
        acc += ";".concat(item.productID, ",");
        return acc;
      }, '');
    }
    return appMeasurement;
  };
  window.adobeAnalyticsMethods.setPropsForCheckoutConfirmation = function (appMeasurement) {
    appMeasurement.products = '';
    var digitalData = window.digitalData;
    if (!digitalData) {
      return appMeasurement;
    }
    var transactionItems = (0, _lodash.default)(digitalData, 'transaction.item');
    if (transactionItems && transactionItems.length > 0) {
      appMeasurement.products = window.adobeAnalyticsMethods.buildProductsVariable(transactionItems);
    }
    appMeasurement.purchaseID = (0, _lodash.default)(digitalData, 'order.purchaseId', '');
    appMeasurement.transactionID = (0, _lodash.default)(digitalData, 'order.purchaseId', '');
    var deliveryMethod = (0, _lodash.default)(digitalData, 'order.deliveryMethod', '');
    if (deliveryMethod === _analytics.deliveryMethodsMap['DTD']) {
      appMeasurement.state = (0, _lodash.default)(digitalData, 'order.deliveryState', '');
      appMeasurement.zip = (0, _lodash.default)(digitalData, 'order.zipCode', '');
    }
    var totalOrderValue = (0, _lodash.default)(digitalData, 'order.totalOrderValue');
    var shippingCost = (0, _lodash.default)(digitalData, 'order.shippingCost');
    var event19 = totalOrderValue > 0 ? ",event19=".concat(totalOrderValue / 100) : '';
    var event20 = shippingCost > 0 ? ",event20=".concat(shippingCost / 100) : '';
    appMeasurement.events = "purchase" + event19 + event20;
    return appMeasurement;
  };

  // dummy this as it's being called by a global script in DTM
  window.adobeAnalyticsTags = {};
  window.adobeAnalyticsTags.buildDataLayerForConfirmationPage = function (s) {
    return s;
  };
  return null;
};
var _default = adobeAppMeasurement;
exports.default = _default;